<div *ngIf="atendentes.length > 0" class="flex flex-col">
  <div class="overflow-x-hidden">
    <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="border-b border-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Disponibilidade
              </th>
              <th scope="col" class="px-2 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Ativo/Inativo
              </th>
              <th scope="col" class="px-2 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Nome
              </th>
              <th scope="col" class="px-2 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                CPF
              </th>
              <th scope="col" class="px-2 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                E-mail
              </th>
              <th scope="col" class="px-2 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Empresa
              </th>
              <th
                scope="col"
                class="px-2 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'attendants.edit', 'attendants.enable', 'attendants.disable']"
              >
                Mais
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white hover:bg-iceberg" *ngFor="let usuario of atendentes">
              <!-- Disponibilidade: status real via AttendantStatus/GetByIds -->
              <td class="px-6 py-4 pl-0 whitespace-nowrap">
                <span *ngIf="usuario.availabilityStatus; else semStatus"
                  class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                  {{ usuario.availabilityStatus }}
                </span>
                <ng-template #semStatus>
                  <span class="text-gray-400">—</span>
                </ng-template>
              </td>
              <!-- Ativo/Inativo baseado em usuario.active -->
              <td class="px-2 py-4 pl-0 whitespace-nowrap">
                <span
                  *ngIf="usuario.active"
                  class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800"
                >Ativo</span>
                <span
                  *ngIf="!usuario.active"
                  class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800"
                >Inativo</span>
              </td>
              <td class="px-3 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ usuario.fullName }}
              </td>
              <td class="px-3 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                <span *ngIf="cpfVisivelIds.has(usuario.id)">{{ usuario.document | mask: '000.000.000-00' }}</span>
                <span *ngIf="!cpfVisivelIds.has(usuario.id)" class="tracking-widest text-gray-400">•••.•••.•••-••</span>
                <button
                  type="button"
                  class="ml-2 text-xs text-blumine underline"
                  (click)="toggleCpfVisivel(usuario.id)"
                >{{ cpfVisivelIds.has(usuario.id) ? 'ocultar' : 'mostrar' }}</button>
              </td>
              <td class="px-3 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ usuario.email }}
              </td>
              <td class="px-3 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ usuario.company?.name }}
              </td>
              <td
                class="flex justify-center flex-1 gap-2 px-3 py-4 whitespace-normal text-md text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'attendants.edit', 'attendants.enable', 'attendants.disable']"
              >
                <button
                  *isAllowed="[ERoleAdminString.Admin, 'attendants.edit']"
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  [routerLink]="'editar/' + usuario.id"
                  title="Editar Atendente"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#000000"
                    width="20"
                    height="20"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </button>

                <button
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  *isAllowed="[ERoleAdminString.Admin, 'attendants.enable', 'attendants.disable']"
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                >
                  <mat-icon class="w-6 h-6">more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <ng-container *ngIf="!usuario.active">
                    <button
                      mat-menu-item
                      (click)="toogleAtendenteStatus(usuario.id!, usuario.active!)"
                      *isAllowed="[ERoleAdminString.Admin, 'attendants.enable']"
                    >
                      <mat-icon>check</mat-icon>
                      <span>Ativar</span>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="usuario.active">
                    <button
                      mat-menu-item
                      (click)="toogleAtendenteStatus(usuario.id!, usuario.active!)"
                      *isAllowed="[ERoleAdminString.Admin, 'attendants.disable']"
                    >
                      <mat-icon>delete</mat-icon>
                      <span>Desativar</span>
                    </button>
                  </ng-container>
                </mat-menu>

                <!-- <button class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  *isAllowed="[ERoleAdminString.Admin, 'attendants.edit']" [routerLink]="'editar/devices/' + usuario.id"
                  title="Editar Dispositivos" mat-icon-button>
                  <mat-icon class="w-6 h-6">computer</mat-icon>
                </button> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<app-no-results-found [condition]="atendentes.length === 0"></app-no-results-found>
<div class="flex justify-end mb-5">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
